import React from 'react';
import Dashboard from '../Dashboard/Dashboard';

const Home = () => {
    return (
        <div>
            <Dashboard/>
        </div>
    );
};

export default Home;